import { EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'

const AssetValidatorsTable = () => {
  const [perPage, setPerPage] = useState(25)
  const [page, setPage] = useState(0)
  const {
    data: validators,
    error,
    isLoading,
    refetch,
  } = useQuery([`validator-field-types?page=${page}&per_page=${perPage}&asset_validators=1`])

  const columns = [
    {
      key: 'validator',
      header: 'Validator',
      render: (data) => (
        <p key={data.id}>
          <b>{data.name}</b>
          <br />
          {data.description}
        </p>
      ),
    },
  ]

  return (
    <DataTable
      caption='Asset validators'
      columns={columns}
      rows={validators?.data ?? []}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      empty={<EmptyState title='No validators found!' detail='Create a new validator to begin.' />}
      pagination={{
        currentPage: page,
        rowsPerPage: perPage,
        onPageChange: setPage,
        onRowsPerPageChange: (perPage) => {
          setPerPage(perPage)
          setPage(0)
        },
      }}
      totalRows={validators?.meta.total}
    />
  )
}

export default AssetValidatorsTable
